import { adapterListResponse } from "./adapters/adapterList";
import axios from "axios";

export const getRecordsDb = async () => {
  try {
    let availableRecords: any = await axios({
      method: "get",
      url: "/api/records",
    })
      .then((response) => {
        let newResponse = adapterListResponse(response.data);
        return newResponse;
      })
      .catch((error) => {
        return false;
      });

    return availableRecords;
  } catch (error) {
    return false;
  }
};
